<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    gap?: 0 | 2 | 4 | 6 | 8 | 12 | 20
    wrap?: 'wrap' | 'nowrap'
    justify?:
      | 'flex-start'
      | 'flex-end'
      | 'center'
      | 'space-between'
      | 'space-around'
    align?: 'flex-start' | 'flex-end' | 'center' | 'baseline' | 'stretch'
    fillMainAxis?: boolean
  }>(),
  {
    gap: 0,
    wrap: 'nowrap',
    justify: 'flex-start',
    align: 'stretch',
    fillMainAxis: false
  }
)
</script>

<template>
  <RFlex
    direction="row"
    :gap="props.gap"
    :wrap="props.wrap"
    :justify="props.justify"
    :align="props.align"
    :fill-main-axis="props.fillMainAxis"
  >
    <slot />
  </RFlex>
</template>
